import React from 'react';
import { Box, HStack, Link as ChakraLink, Text } from '@chakra-ui/react';
import { Link, useLocation, useMatch } from 'react-router-dom';

const ShareViewerBanner: React.FC = () => {
  const drilldown = useMatch('/share/dashboard/:companyId');
  const location = useLocation();

  return (
    <Box
      bg="gray.50"
      color="gray.700"
      borderBottom="1px solid"
      borderColor="gray.200"
      fontFamily="Inter, sans-serif"
      fontSize="sm"
      fontWeight="500"
      py={3}
      px={{ base: 4, md: 8 }}
    >
      <HStack spacing={4}>
        {drilldown && (
          <ChakraLink
            as={Link}
            to={{
              pathname: '/share/dashboard',
              search: location.search,
              hash: location.hash,
            }}
            color="gray.700"
            _hover={{ color: 'gray.900', textDecoration: 'none' }}
          >
            ← Platform health
          </ChakraLink>
        )}
        <Text>Read-only board view</Text>
      </HStack>
    </Box>
  );
};

export default ShareViewerBanner;
